<template>
    <div class="modal fade" tabindex="-1" id="ModalDoutrina">
        <div class="modal-dialog modal-fullscreen w-100">
            <div class="modal-content border-0">
                <div class="modal-body">
                    <div class="mt-5">
                        <h3 class="title"></h3>
                        <hr />
                        <div class="form">
                            <div class="row">
                                <div class="col-12">
                                    <iframe :src="getTipoDoutrina(tipo)" type="application/pdf" width="100%" style="overflow: auto; padding: 0px; background-color: rgb(196, 196, 196); box-shadow: rgba(0, 0, 0, 0.25) 5px 0px 10px inset; height: calc(-6rem + 100vh); " />
                                </div>
                            </div>
                        </div>
                    </div>
                </div><!-- .modal-body -->
                <button class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-3 me-3" data-bs-dismiss="modal">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                        <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                    </svg><!-- x-lg -->
                </button><!-- modal-close -->
            </div><!-- .modal-content -->
        </div><!-- .modal-dialog -->
    </div><!-- .modal -->
</template>

<script>

    export default {
        name: 'ModalDoutrina',
        data: function () {
            return {
            }
        },
        props: {
            showModal: Boolean,
            tipo: Number,
        },
        methods: {
            load() {

            },

            close() {
                const myModalAlternative = new window.bootstrap.Modal('#ModalDoutrina');
                myModalAlternative.hide();
            },


            getTipoDoutrina(tipo) {
                let url = "livro_doutrina.pdf";
                switch (tipo) {
                    case 0:
                        url = '/livros/livro_doutrina.pdf';
                        break;

                    case 1:
                        url = '/livros/livro_governanca.pdf';
                        break;

                    case 2:
                        url = '/livros/caderno_pesquisa_precos_mgi.pdf';
                        break;

                    case 3:
                        url = '/livros/instrumento_padronizacao_agu.pdf';
                        break;

                    case 4:
                        url = '/livros/instrumento_padronizacao_ti_agu.pdf';
                        break;

                    case 5:
                        url = '/livros/perguntas_frequentes_agu.pdf';
                        break;

                    case 6:
                        url = '/livros/referencial_basico_gestao_riscos.pdf';
                        break;
                    case 7:
                        url = '/livros/sistemaS/Artigo A Atuação Sistêmica e Sinergia nas Entidades do Sistema S.pdf';
                        break;

                    case 8:
                        url = '/livros/sistemaS/Artigo A Autonomia Administrativa das Entidades do Sistema S.pdf';
                        break;
                    case 9:
                        url = '/livros/sistemaS/artigo Contratos do Sistema S.pdf';
                        break;
                    case 10:
                        url = '/livros/sistemaS/Artigo Novos Regulamentos de Contratações do Sistema S.pdf';
                        break;
                    case 11:
                        url = '/livros/sistemaS/Artigo Reforma das contratações do Sistema S.pdf';
                        break;
                    case 12:
                        url = '/livros/sistemaS/Artigo Regulamento de Contratação das Entidades do Sistema S.pdf';
                        break;
                    case 13:
                        url = '/livros/sistemaS/Artigo Retrospectiva Sistema S Princípios da Administração Pública.pdf';
                        break;
                    case 14:
                        url = '/livros/sistemaS/Ebook Pesquisa_de_Mercado_no_Sistema_S.pdf';
                        break;
                    case 15:
                        url = '/livros/sistemaS/ebook sistema S Boas Praticas.pdf';
                        break;
                    case 16:
                        url = '/livros/sistemaS/O TCU e o Sistema S - Portal TCU.pdf';
                        break;
                    case 17:
                        url = '/livros/sistemaS/orientacaoSollicita.pdf';
                        break;
                    case 18:
                        url = '/livros/sistemaS/Sistema S e Licitações - Portal do TCU.pdf';
                        break;
                }
                return url;
            },

        },
        created: function () {
            this.load();
        },
        watch: {
            showModal: function () {
                const myModalAlternative = new window.bootstrap.Modal('#ModalDoutrina');
                myModalAlternative.show();
            },
            tipo: function () {
                this.load();
            },
        }

    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /* Modal Doutrina */
    .form-control {
        border: 1px solid #474747;
    }

</style>

